/* eslint-disable camelcase */
/* @flow strict */

import React from 'react';
import { currency } from '/client/src/constants/';

// TODO All this functions are copied to utils/amountTransformation
function trimEndZero(src: string) {
  src = src.toString();
  if (/\.00$/.test(src)) {
    return src.replace(/\.00$/, '');
  }
  return src;
}

function digitalToSize(digital, interval, sizes, isRounding) {
  if (digital > 0 && digital < 1) {
    return digital;
  }
  if (digital < 0 && digital > -1) {
    return digital;
  }
  if (digital === 0) return digital;
  const i = Math.floor(Math.log(digital) / Math.log(interval));

  let r: any = (digital / Math.pow(interval, i)).toPrecision(3);

  if (isRounding) {
    r = parseFloat(r);
  }
  return trimEndZero(r) + sizes[i];
}

function moneyToSize(digital, isRounding = false) {
  return digitalToSize(digital, 1000, ['', 'k', 'm', 'b'], isRounding);
}

const format = ($symbol, amount = null, moneyToSize = false) => {
  let symbol;

  let symbol_html = '';

  if ($symbol) {
    // symbol = api.getSymbol($symbol);
    symbol_html = `${$symbol}`;
  }
  if (amount === null) {
    return symbol_html;
  }
  let amount_num = (amount / 100).toFixed(2);

  if (amount === 0) {
    amount_num = '0';
  }
  if (moneyToSize) {
    amount_num = `${  moneyToSize(+amount_num, false)}`;
  }
  const amount_html = `${amount_num}`;

  return symbol_html + trimEndZero(amount_html);
};

export const columns = (): [] => {
  return [
    {
        selector: 'referral_user_name',
        name: 'Referral Name',
        sortable: true,
        wrap: true
    },
    {
        selector: 'view_count',
        name: 'Page Views',
        sortable: true
    },
    {
        selector: 'totalSales',
        name: 'Total Sales',
        sortable: true,
        cell: (row: {}): string => {
          return format(currency[row.currency], row.total_sales);
          // return `${currency[row.currency]}${row.amount - row.amount_refund}`;
        }
    },
    {
        selector: 'ticketsSold',
        name: '# Of tickets sold',
        sortable: true,
        cell: (row: {}): string => {
          return row.tickets_sold;
        }
    },
    {
        selector: 'ticketsRewarded',
        name: 'Tickets Rewarded',
        sortable: true,
        cell: (row: {}): string => {
          return row.tickets_rewarded;
        }
    },
    {
        selector: 'referral_type',
        name: 'Referral Type',
        sortable: true,
        minWidth: '200px'
    }
  ];
};
